import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/component_wrapper/grid_pager.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Component from "./common/component";
export var GridPagerWrapper =
/*#__PURE__*/
function (_Component) {
  _inherits(GridPagerWrapper, _Component);

  function GridPagerWrapper() {
    _classCallCheck(this, GridPagerWrapper);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridPagerWrapper).apply(this, arguments));
  }

  _createClass(GridPagerWrapper, [{
    key: "_optionChanged",
    value: function _optionChanged(args) {
      switch (args.name) {
        case "pageIndex":
          var pageIndexChanged = this.option("pageIndexChanged");

          if (pageIndexChanged) {
            pageIndexChanged(args.value);
          }

          break;

        case "pageSize":
          var pageSizeChanged = this.option("pageSizeChanged");

          if (pageSizeChanged) {
            pageSizeChanged(args.value);
          }

      }

      _get(_getPrototypeOf(GridPagerWrapper.prototype), "_optionChanged", this).call(this, args);
    }
  }]);

  return GridPagerWrapper;
}(Component);